function saveToLocalStorage(key: string, value: unknown) {
  localStorage.setItem(key, JSON.stringify(value))
}

export { saveToLocalStorage }
